import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import TermsBanner from "./terms-conditions-banner";
import TermsDescriptions from "./terms-conditions-descriptions";

import * as apiUrl from "../../apiUrl";

function TermsConditionsPage() {
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/terms-conditions/page`
        );
        if (!response.ok) {
          throw new Error("Page not found");
        }
        const data = await response.json();
        setPageData(data);
      } catch (error) {
        console.error("Error fetching page:", error);
      }
    };

    fetchPage();
  }, []);

  return (
    <Fragment>
      <Header />
      <TermsBanner
        bannerImage={pageData.banner_image}
        bannerTitle={pageData.banner_title}
      />
      <TermsDescriptions description={pageData.description} />
      <Footer />
    </Fragment>
  );
}

export default TermsConditionsPage;
